module.exports = __webpack_public_path__ + "1c53d4670ec1971df6be342407a8e521.pdf";